<template>
    <div>
        <div class="form-group">
            <label class="control-label">Company</label>
            <company v-model="model.company" :min-length="0"></company>
        </div>

        <div class="form-group">
            <label class="control-label">Subject</label>
            <input class="form-control" type="text" v-model="model.subject">
        </div>

        <list v-model="model.priority" label="Priority" :list="['Low', 'Medium', 'High', 'Urgent']"></list>

        <ckeditor :id="id" v-model="model.description"></ckeditor>

        <div class="buttons">
            <button @click.prevent="store" type="submit" class="btn btn-success btn-sm">
                <span>Create</span>
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        components: {
            'ckeditor': require('../ckeditor/ckeditor.vue').default,
            'company': require('../../components/autocomplete/company.vue').default,
        },
        data() {
            return {
                id: this.uniqueid(),
                closePanel: true,
                model: {
                    priority: 'Low',
                    company: '',
                    subject: '',
                    description: '',
                }
            }
        },
        created() {
        },
        methods: {
            callback(data) {
                // this.$eventHub.$emit('closeRightPanel');
            },
            store() {
                this.$store('/api/ticket/create', this);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
        }
    }
</script>
<style>
    #savedLinks {
        text-align: center;
        min-height: 100px;
    }
    .clickable{
        cursor: pointer;
    }
</style>